import React, { useState /* , useCallback */ } from 'react';
import styles from './index.module.less';
import moment from 'moment';
import {
  Radio,
  Button,
  Row,
  Col,
  Card,
  Empty,
  Tooltip,
  // Tag,
  // Popconfirm,
  Space,
  Modal,
  Input,
  message
} from 'antd';
//import plus from '../../images/plus.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from 'common/Content/CustomTable';
import {
  // EditOutlined,
  ArrowLeftOutlined,
  // PlusOutlined,
  UploadOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import { history } from 'app/history';
// import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
//import LocalStorage from 'utilities/localStorage';
//import AllExportReports from '../../../../../features/admin/components/adminPage/reports/AllExportReports';
import { user_bulk_upload_direct_approve } from '../../../redux/slice';
import FormData from 'form-data';

const filters = [
  /*  {
    name: 'Gift Received',
    value: ''
  },
  {
    name: 'Pending',
    value: 'pending'
  },
  {
    name: 'Accepted',
    value: 'accepted'
  },
  {
    name: 'Rejected',
    value: 'rejected'
  } */
];

function UserBulkUploadFlowPage({
  radiofilter,
  setRadiofilter,
  setTriggerFilter,
  page,
  setPage,
  pageSize,
  setPageSize,
  setSearchRequest,
  adminBulkGiftConfigs,
  adminBulkGiftConfigsLoading,
  pagination
}) {
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    user_bulk_upload_direct_approveLoading: bulkUploadDirectApproveLoading
  } = useSelector((state) => state.dashboard);

  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [selectedConfigRecord, setSelectedConfigRecord] = useState(null);
  const [fileValue, setFileValue] = useState('');
  const [fileName, setFileName] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const showErrorModal = (msg) => {
    setErrorMessage(msg);
    setIsErrorModalOpen(true);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
    setErrorMessage('');
  };

  // Map bulk gift configs data for table display
  const bulkGiftConfigsList = adminBulkGiftConfigs?.map((item) => {
    return {
      key: item?.id,
      id: item?.id,
      upldFrmDate: item?.upldFrmDate || 'N/A',
      upldToDate: item?.upldToDate || 'N/A',
      fiscalYear: item?.fiscalYear || 'N/A',
      giftsFrmDate: item?.giftsFrmDate || 'N/A',
      giftsToDate: item?.giftsToDate || 'N/A',
      projectSiteName: item?.ProjectSite?.name || 'N/A',
      type: item?.type || 'N/A',
      status:
        item?.isActive !== undefined
          ? item?.isActive
          : item?.status !== undefined
          ? item?.status
          : true
    };
  });
  console.log('bulkGiftConfigsList', bulkGiftConfigsList);
  // const handleBU_record = (record) => {
  //   console.log('RRRRRRRRR@@@@@@@@@@', record);
  //   history.push(`edit-roUsers-flow/${record.id}`);
  //   LocalStorage.setItem('roUsers_record', JSON.stringify(record));
  // };

  //const [isAllExortModalOpen, setAllExortModalOpen] = useState(false);

  const downloadTemplate = () => {
    const downloadUrl = '/user_bulk_upload_template.xlsx';
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'user_bulk_upload_template.xlsx'; //'Template_Bulk_Upload.xlsx';
    link.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setFileName(file.name);
    } else {
      setSelectedFile(null);
      setFileName(null);
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setFileName(null);
    setFileValue('');
  };

  const handleOpenBulkUploadModal = (record) => {
    setSelectedConfigRecord(record);
    setIsBulkUploadModalOpen(true);
    setSelectedFile(null);
    setFileName(null);
    setFileValue('');
  };

  const handleCloseBulkUploadModal = () => {
    setIsBulkUploadModalOpen(false);
    setSelectedConfigRecord(null);
    setSelectedFile(null);
    setFileName(null);
    setFileValue('');
  };

  const handleSubmitBulkUpload = () => {
    if (!selectedConfigRecord?.id) {
      message.error('Missing bulk upload configuration id.');
      return;
    }

    if (!selectedFile) {
      message.error('Please select a file to upload.');
      return;
    }

    const formdata = new FormData();
    formdata.append('id', selectedConfigRecord.id);
    formdata.append('file', selectedFile);

    dispatch(user_bulk_upload_direct_approve(formdata)).then((response) => {
      if (response?.payload?.success) {
        message.success(
          response?.payload?.message || 'Bulk upload submitted successfully'
        );
        handleCloseBulkUploadModal();
      } else if (response?.payload?.message) {
        // message.error(response.payload.message);
        showErrorModal(response.payload.message);
      } else {
        // message.error(response?.payload?.msg);
        showErrorModal(response?.payload?.msg || 'Something went wrong');
      }
    });
  };

  const isDateInRange = (upldFrmDate, upldToDate) => {
    if (
      !upldFrmDate ||
      !upldToDate ||
      upldFrmDate === 'N/A' ||
      upldToDate === 'N/A'
    ) {
      return false;
    }
    const currentDate = moment().startOf('day');
    const fromDate = moment(upldFrmDate).startOf('day');
    const toDate = moment(upldToDate).startOf('day');
    return (
      currentDate.isSameOrAfter(fromDate) && currentDate.isSameOrBefore(toDate)
    );
  };

  const columns = [
    {
      title: 'Start Date',
      dataIndex: 'upldFrmDate',
      key: 'upldFrmDate',
      ellipsis: true,
      sorter: (a, b) => a?.upldFrmDate?.localeCompare(b?.upldFrmDate),
      render: (upldFrmDate) => {
        const formattedDate = upldFrmDate
          ? moment(upldFrmDate).format('DD MMM YYYY')
          : 'N/A';
        return (
          <>
            <Tooltip
              title={formattedDate}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {formattedDate}
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'End Date',
      dataIndex: 'upldToDate',
      key: 'upldToDate',
      ellipsis: {
        showTitle: false
      },
      sorter: (a, b) => a?.upldToDate?.localeCompare(b?.upldToDate),
      render: (upldToDate) => {
        const formattedDate = upldToDate
          ? moment(upldToDate).format('DD MMM YYYY')
          : 'N/A';
        return (
          <>
            <Tooltip
              title={formattedDate}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              <span className={styles.text_transform}>{formattedDate}</span>
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Fiscal Year',
      dataIndex: 'fiscalYear',
      key: 'fiscalYear',
      ellipsis: true,
      sorter: (a, b) => a?.fiscalYear?.localeCompare(b?.fiscalYear),
      render: (fiscalYear) => {
        return (
          <>
            <Tooltip
              title={fiscalYear}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {fiscalYear === null || fiscalYear === '' ? 'N/A' : fiscalYear}
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Project Site',
      dataIndex: 'projectSiteName',
      key: 'projectSiteName',
      ellipsis: {
        showTitle: false
      },
      sorter: (a, b) => a?.projectSiteName?.localeCompare(b?.projectSiteName),
      render: (projectSiteName) => {
        return (
          <>
            <Tooltip
              title={projectSiteName}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              <span className={styles.text_transform}>
                {projectSiteName === null || projectSiteName === 'N/A'
                  ? 'N/A'
                  : projectSiteName}
              </span>
            </Tooltip>
          </>
        );
      }
    },
    /*  {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      //width: '120px',
      ellipsis: true,
      //sorter: (a, b) => a?.status?.localeCompare(b?.status),
      render: (status, record) => (
        <Tag
          className={`${styles.status_style}`}
          color={
            record?.status === true
              ? 'green'
              : record?.status === false
              ? 'red'
              : 'transparent'
          }
        >
          {record?.status === true ? 'ACTIVE' : 'DEACTIVATED'}
        </Tag>
      )
    }, */
    {
      title: 'Action',
      key: '',
      width: 180,
      render: (record) => {
        const isEnabled = isDateInRange(
          record?.upldFrmDate,
          record?.upldToDate
        );
        return (
          <Space size="middle">
            <Button
              className={`${styles.bulk_upload_button}`}
              onClick={() => handleOpenBulkUploadModal(record)}
              disabled={!isEnabled}
            >
              {record?.type}
            </Button>
          </Space>
        );
      }
    }
  ];

  // const visibility = useCallback((record) => {
  //   return showDisablePopup[record.id];
  // }, showDisablePopup);

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        <div className={styles.empty_state_text}>
          There are no Bulk Gift Configs to display
        </div>
      </span>
    )
  };

  return (
    <>
      <div className={`${styles.container}`}>
        <Row className={`${styles.row_container}`}>
          <div className={`${styles.gift_container}`}>
            <div className={`${styles.myGift_title}`}>
              Configure Bulk Uploaded Gifts
            </div>
            <div className={`${styles.myGift_text}`}>
              View and manage Bulk uploaded Gifts
            </div>
          </div>

          <Row>
            {/*  <Button
              className={`${styles.export_button}`}
              onClick={() => setAllExortModalOpen(true)}
            >
              Export
            </Button>
            <Button
              className={`${styles.declareGift_button}`}
              icon={<PlusOutlined />}
              onClick={() => history.push('/create-bulk-upload-flow')}
            >
              Add Bulk upload
            </Button> */}
            <Button
              style={{ marginLeft: '20px' }}
              className={`${styles.declareGift_button}`}
              icon={<ArrowLeftOutlined />}
              onClick={() => history.push('/welcome')}
            >
              Back
            </Button>
          </Row>
        </Row>
        <div className={`${styles.tabs_container}`}>
          <Row>
            {/* className={`${styles.row_container}`} */}
            <Col span={16}>
              <Radio.Group
                value={radiofilter}
                size="small"
                className={`${styles.button_import_style}`}
              >
                {filters.map((item, index) => {
                  return (
                    <Radio.Button
                      value={item.value}
                      key={index}
                      //className={`${styles.RadioButton_import_style}`}
                      onChange={() => {
                        window.localStorage.setItem(
                          'set_Radiofilter',
                          JSON?.stringify(item.value)
                        );
                        setRadiofilter(item.value);
                        setTriggerFilter(true);
                      }}
                    >
                      {item.name}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Col>
            <Col span={8}>
              <SearchBar
                onChange={(e) => {
                  setSearchRequest(e.target.value);
                  setTriggerFilter(true);
                }}
                className={` ${styles.searchbar}`}
                inputProps={{
                  placeholder: 'Search by fiscal year'
                }}
              />
            </Col>
          </Row>
        </div>
        <Card className={`${styles.cardStyles}`}>
          <div className={`${styles.table_container}`}>
            <CustomTable
              columns={columns}
              dataSource={bulkGiftConfigsList || []}
              locale={locale}
              loading={adminBulkGiftConfigsLoading}
              pagination={{
                current: page,
                pageSize: pageSize,
                showSizeChanger: true,
                size: 'small',
                total: pagination?.total_records || pagination?.total || 0,
                onChange: (page, pageSize) => {
                  setPage(page);
                  setPageSize(pageSize);
                }
              }}
            />
          </div>
        </Card>
        {/*  {isAllExortModalOpen ? (
          <AllExportReports
            isAllExortModalOpen={isAllExortModalOpen}
            setAllExortModalOpen={setAllExortModalOpen}
            apiName={'project_sites_master'}
          />
        ) : (
          ''
        )} */}
        <Modal
          title="Bulk Upload"
          open={isBulkUploadModalOpen}
          onCancel={handleCloseBulkUploadModal}
          footer={null}
          destroyOnClose
          width={900}
        >
          <Card className={`${styles.cardStyles1}`}>
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ marginRight: '15px' }}>
                <a onClick={downloadTemplate}>
                  Download template for Bulk Upload
                </a>
              </span>
              <span className={`${styles.browse_container}`}>
                <label
                  htmlFor="user-bulk-file-upload"
                  className={styles.custom_file_upload}
                >
                  <UploadOutlined /> Browse
                </label>
                <Input
                  value={fileValue}
                  accept="*"
                  className={styles.upload}
                  type="file"
                  onChange={(e) => {
                    setFileValue('');
                    handleFileChange(e);
                  }}
                  id="user-bulk-file-upload"
                />
                {fileName && (
                  <div>
                    <DeleteOutlined
                      className={`${styles.delete_uploaded_file}`}
                      onClick={handleRemoveFile}
                    />
                    <span
                      style={{
                        fontSize: '12px',
                        fontFamily: 'SFProText Regular',
                        color: '#9E9E9E'
                      }}
                    >
                      {fileName}
                    </span>
                  </div>
                )}
              </span>
            </Row>
          </Card>
          <Row style={{ marginTop: '20px', justifyContent: 'flex-end' }}>
            <Button
              className={`${styles.cancel_button}`}
              size="middle"
              onClick={handleCloseBulkUploadModal}
              style={{ marginRight: '8px' }}
            >
              Cancel
            </Button>
            <Button
              loading={bulkUploadDirectApproveLoading}
              className={`${styles.submit_button}`}
              size="middle"
              type="primary"
              onClick={handleSubmitBulkUpload}
              disabled={!selectedFile}
            >
              Submit
            </Button>
          </Row>
        </Modal>
      </div>
      <Modal
        open={isErrorModalOpen}
        onCancel={closeErrorModal}
        footer={null}
        centered={false}
        style={{ top: 350 }}
        width={600}
        destroyOnClose
      >
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <div style={{ color: '#FF4D4F', fontSize: '18px' }}>✖</div>

          <div>
            {/* <div
              style={{
                fontSize: '16px',
                fontWeight: 600,
                marginBottom: '8px',
                color: '#1F1F1F'
              }}
            >
              Error
            </div> */}

            <div
              style={{
                fontSize: '14px',
                color: '#595959',
                lineHeight: '1.5',
                paddingTop: '3px'
              }}
            >
              {errorMessage}
            </div>
          </div>
        </div>

        {/* <div style={{ textAlign: 'right', marginTop: '24px' }}>
          <Button type="primary" danger onClick={closeErrorModal}>
            Close
          </Button>
        </div> */}
      </Modal>
    </>
  );
}
export default UserBulkUploadFlowPage;
